import { createContext } from 'react';

import { FeatureAppDependencies } from '../FeatureAppDefinition';
import { useSafeContext } from './use-safe-context';

export const FeatureServicesContext = createContext<
  FeatureAppDependencies | undefined
>(undefined);

export function useFeatureServices(): FeatureAppDependencies {
  return useSafeContext(FeatureServicesContext, 'featureServices');
}
